(function () {
  const calcMinHeight = () => {
    const facetsTop = document.querySelector(".facets__top");
    const sortWrapper = document.querySelector(".facets__sort-wrapper");
    const collectionWrapper = document.querySelector(".collection-wrapper");

    if (facetsTop && sortWrapper && collectionWrapper) {
      collectionWrapper.style.gridTemplateRows =
        sortWrapper.getBoundingClientRect().height + "px auto 1fr";
    }
  };

  const resizeCollectionGrid = () => {
    const collectionGridSection =
      document.querySelector(".collection-grid-section") ||
      document.querySelector(".section-search");

    if (!collectionGridSection) return;

    const sectionResizeObserver = new ResizeObserver(() => {
      calcMinHeight();
    });

    sectionResizeObserver.observe(collectionGridSection);
  };

  document.addEventListener("shopify:section:load", function () {
    resizeCollectionGrid();
  });

  resizeCollectionGrid();
})();

/* Spring Step Shoes — mobile collection grid switcher (Rework theme only) */
(function () {
  const STORAGE_KEY = "sss-mobile-collection-grid";
  const ROOT_ATTRIBUTE = "data-sss-mobile-collection-grid";
  let scheduled = false;

  const addStyles = () => {
    if (document.getElementById("sss-mobile-collection-grid-styles")) return;

    const style = document.createElement("style");
    style.id = "sss-mobile-collection-grid-styles";
    style.textContent = `
      .sss-mobile-grid-toggle { display: none; }

      @media screen and (max-width: 575px) {
        .sss-mobile-grid-toggle {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 0.2rem;
          margin-left: auto;
          flex: 0 0 auto;
        }

        .sss-mobile-grid-toggle__button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 3.4rem;
          height: 3.4rem;
          padding: 0;
          border: 0;
          background: transparent;
          color: rgb(var(--color-foreground));
          opacity: 0.38;
          cursor: pointer;
          transition: opacity 160ms ease;
        }

        .sss-mobile-grid-toggle__button:hover,
        .sss-mobile-grid-toggle__button:focus-visible,
        .sss-mobile-grid-toggle__button.is-active {
          opacity: 1;
        }

        .sss-mobile-grid-toggle__button:focus-visible {
          outline: 1px solid currentColor;
          outline-offset: 2px;
        }

        .sss-mobile-grid-toggle__button svg {
          width: 1.7rem;
          height: 1.7rem;
          display: block;
        }

        html[${ROOT_ATTRIBUTE}="1"] .collection-grid-section .collection-product-list {
          grid-template-columns: minmax(0, 1fr) !important;
        }

        html[${ROOT_ATTRIBUTE}="2"] .collection-grid-section .collection-product-list {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        }

        html[${ROOT_ATTRIBUTE}="1"] .collection-grid-section .collection-product-promo-img,
        html[${ROOT_ATTRIBUTE}="1"] .collection-grid-section .collection-product-promo-img-promo {
          grid-column: 1 / -1 !important;
        }

        html[${ROOT_ATTRIBUTE}="2"] .collection-grid-section .collection-product-promo-img,
        html[${ROOT_ATTRIBUTE}="2"] .collection-grid-section .collection-product-promo-img-promo {
          grid-column: 1 / -1 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getSavedChoice = () => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      return saved === "1" || saved === "2" ? saved : null;
    } catch (error) {
      return null;
    }
  };

  const getDefaultChoice = () => {
    const saved = getSavedChoice();
    if (saved) return saved;
    return document.querySelector(".collection-product-list--2-mobile") ? "2" : "1";
  };

  const updateButtons = (columns) => {
    document.querySelectorAll("[data-sss-mobile-grid-columns]").forEach((button) => {
      const active = button.dataset.sssMobileGridColumns === columns;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  };

  const applyChoice = (columns, persist) => {
    if (columns !== "1" && columns !== "2") return;
    document.documentElement.setAttribute(ROOT_ATTRIBUTE, columns);
    updateButtons(columns);

    if (persist) {
      try {
        window.localStorage.setItem(STORAGE_KEY, columns);
      } catch (error) {
        // Storage can be unavailable in private browsing; the toggle still works for this page.
      }
    }
  };

  const buildToggle = () => {
    if (!document.querySelector(".collection-grid-section")) return;

    const wrappers = document.querySelectorAll(".facets__sort-wrapper");
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      if (wrapper.querySelector(".sss-mobile-grid-toggle")) return;

      const toggle = document.createElement("div");
      toggle.className = "sss-mobile-grid-toggle";
      toggle.setAttribute("role", "group");
      toggle.setAttribute("aria-label", "Products per row");
      toggle.innerHTML = `
        <button type="button" class="sss-mobile-grid-toggle__button" data-sss-mobile-grid-columns="1" aria-label="Show one product per row" aria-pressed="false">
          <svg viewBox="0 0 18 18" aria-hidden="true" focusable="false">
            <rect x="3" y="2.5" width="12" height="5" fill="none" stroke="currentColor" stroke-width="1"/>
            <rect x="3" y="10.5" width="12" height="5" fill="none" stroke="currentColor" stroke-width="1"/>
          </svg>
        </button>
        <button type="button" class="sss-mobile-grid-toggle__button" data-sss-mobile-grid-columns="2" aria-label="Show two products per row" aria-pressed="false">
          <svg viewBox="0 0 18 18" aria-hidden="true" focusable="false">
            <rect x="2" y="2.5" width="6" height="5" fill="none" stroke="currentColor" stroke-width="1"/>
            <rect x="10" y="2.5" width="6" height="5" fill="none" stroke="currentColor" stroke-width="1"/>
            <rect x="2" y="10.5" width="6" height="5" fill="none" stroke="currentColor" stroke-width="1"/>
            <rect x="10" y="10.5" width="6" height="5" fill="none" stroke="currentColor" stroke-width="1"/>
          </svg>
        </button>
      `;

      const perRow = wrapper.querySelector(".per-row__wrapper");
      if (perRow) {
        wrapper.insertBefore(toggle, perRow);
      } else {
        wrapper.appendChild(toggle);
      }
    });

    updateButtons(document.documentElement.getAttribute(ROOT_ATTRIBUTE) || getDefaultChoice());
  };

  const init = () => {
    addStyles();
    applyChoice(document.documentElement.getAttribute(ROOT_ATTRIBUTE) || getDefaultChoice(), false);
    buildToggle();
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-sss-mobile-grid-columns]");
    if (!button) return;
    applyChoice(button.dataset.sssMobileGridColumns, true);
  });

  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      buildToggle();
    });
  });

  const startObserver = () => {
    const target =
      document.querySelector(".collection-wrapper") ||
      document.querySelector(".section-search") ||
      document.getElementById("MainContent");
    if (target) observer.observe(target, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      init();
      startObserver();
    }, { once: true });
  } else {
    init();
    startObserver();
  }

  document.addEventListener("shopify:section:load", init);
})();
